import { ServerPushConsumer } from './server-push-consumer.mjs';
import { Singleton } from './singleton.mjs';

const disconnect = () => {
  const serverPushConsumer = Singleton.getInstance(ServerPushConsumer);
  return serverPushConsumer.disconnect();
};

export { disconnect };
//# sourceMappingURL=disconnect.mjs.map
